import _ from 'lodash';
import React, { Component } from 'react';
import shallowEqual from 'fbjs/lib/shallowEqual';
import SvgIcon from 'material-ui/SvgIcon';
import PropTypes from 'prop-types';
import Radium from 'radium';

@Radium
/**
 * @deprecated Avoid using this class, its breaking mui control of font color in buttons
 */
export default class CustomSvgIcon extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    const {
      path,
      width,
      height,
      color,
      style,
      viewBox,
      hoverColor
      } = this.props;
    const colorFromStyle = style.color;
    return (
      <span style={[{width: width, height: height, display: 'inline-flex'}, _.omit(style, ['width', 'height', 'display'])]}>
        <SvgIcon viewBox={viewBox} color={color || colorFromStyle} hoverColor={hoverColor}
                 style={{width: 'inherit', height: 'inherit'}}>
          <path d={path}/>
        </SvgIcon>
      </span>
    );
  }
}

CustomSvgIcon.propTypes = {
  path: PropTypes.string.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.any.isRequired,
  viewBox: PropTypes.string.isRequired,
  style: PropTypes.object,
  hoverColor: PropTypes.string,
  color: PropTypes.string
};

CustomSvgIcon.defaultProps = {
  viewBox: '0 0 24 24',
  width: '24px',
  height: '24px',
  style: {}
};